import React from "react";
import Layout from "../Layout";
import { Box, Typography, Card } from "@mui/material";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

function Rules() {
  const { data, loading, error } = useFetchWithAuth("/info/faq/");

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <Layout>
      <Card sx={{ p: 3, boxShadow: "none" }} className="rmui-card">
        <Typography variant="h4" sx={{ mb: 3 }}>
          Правила роботи
        </Typography>

        {Array.isArray(data) &&
          data.map((block) => (
            <Box key={block.id} sx={{ mb: 4 }}>
              {block.items?.map((rule, idx) => (
                <Box key={idx} className="border-bottom" sx={{ mb: 2, pb: 2 }}>
                  <Typography variant="h6">{rule.title}</Typography>
                  <Typography
                    sx={{ maxWidth: "550px", whiteSpace: "pre-line" }}
                  >
                    {rule.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
      </Card>
    </Layout>
  );
}

export default Rules;
